import { FileEdit, Globe2, Send } from "lucide-react";

/** Quy trình nội dung — khớp services/locationWorkflowService.js ở backend. */
export const STATUS_META = {
  draft: { label: "Nháp", icon: FileEdit, badge: "bg-slate-100 text-slate-700 ring-slate-200", dot: "bg-slate-400", hint: "Đang soạn, chưa hiện trên website" },
  review: { label: "Chờ duyệt", icon: Send, badge: "bg-amber-50 text-amber-700 ring-amber-200", dot: "bg-amber-500", hint: "Đã gửi, chờ người duyệt đăng" },
  published: { label: "Đã đăng", icon: Globe2, badge: "bg-emerald-50 text-emerald-700 ring-emerald-200", dot: "bg-emerald-500", hint: "Đang hiển thị trên website" },
};

/** Chỉ còn 2 trạng thái: Nháp / Đã đăng. "review" (Chờ duyệt) chỉ còn để hiển thị dữ liệu cũ. */
export const STATUS_ORDER = ["draft", "published"];

const textLen = (s) => String(s || "").replace(/<[^>]*>/g, "").trim().length;

/**
 * Độ hoàn thiện nội dung (0–100) + các mục còn thiếu — khớp cổng đăng ở backend.
 * Bắt buộc để đăng: ảnh, mô tả ≥ 80 ký tự. Nên có: giới thiệu ngắn, SEO, thư viện ≥ 3 ảnh.
 */
export function completenessOf(loc) {
  const img = typeof loc?.image === "string" ? loc.image : loc?.image?.url;
  const checks = [
    { key: "image", required: true, ok: Boolean(img), label: "Ảnh đại diện" },
    { key: "description", required: true, ok: textLen(loc?.description) >= 80, label: "Mô tả ≥ 80 ký tự" },
    { key: "shortIntro", required: false, ok: Boolean(String(loc?.shortIntro || "").trim()), label: "Giới thiệu ngắn" },
    { key: "seo", required: false, ok: Boolean(loc?.seoTitle && loc?.seoDescription), label: "Tiêu đề & mô tả SEO" },
    { key: "gallery", required: false, ok: Array.isArray(loc?.gallery) && loc.gallery.length >= 3, label: "Thư viện ≥ 3 ảnh" },
  ];
  const done = checks.filter((c) => c.ok).length;
  return { percent: Math.round((done / checks.length) * 100), checks, missing: checks.filter((c) => !c.ok), blockers: checks.filter((c) => c.required && !c.ok) };
}

export const statusOf = (loc) => loc?.status || (loc?.isActive === false ? "draft" : "published");

/** Các chuyển trạng thái hợp lệ cho một địa điểm, theo quyền của người dùng (Nháp ↔ Đã đăng). */
export function transitionsFor(status, can) {
  const out = [];
  if (!can("locations:publish")) return out;
  if (status === "draft" || status === "review") {
    out.push({ to: "published", label: "Đăng", hint: "Hiển thị trên website", tone: "primary" });
  }
  if (status === "review") {
    out.push({ to: "draft", label: "Chuyển về nháp", hint: "Chưa hiển thị trên website", needNote: false });
  }
  if (status === "published") {
    out.push({ to: "draft", label: "Gỡ xuống (về nháp)", hint: "Ẩn khỏi website", needNote: false, tone: "danger" });
  }
  return out;
}
